@if (isModal) {
  <div class="modal-header">
    <div class="modal-toolbar">
      <div>
        <div class="modal-title">Stock Item Disabling</div>
        <div class="modal-title">
          <app-display-icon
            (click)="close()"
            [border]="false"
            [colour]="iconColourEnum.primary"
            [icon]="icons.close">
          </app-display-icon>
        </div>
      </div>
    </div>
  </div>
}

<div class="app-content">
  <div id="explanation">
    <p [hidden]="hide.explanation">
      "Disabling" a stock item from this page will actually just modify the item in IQ to be easily recognisable,
      as well as set the on hold type of the item to prevent unintentional usage of the item entry.<br>
      <i>Full item removal from IQ TBA.</i>
    </p>
    <div>
      <app-display-icon
        (click)="hide.explanation = !hide.explanation"
        [border]="false"
        [colour]="iconColourEnum.primary"
        [icon]="hide.explanation ? icons.chevronDown : icons.chevronUp">
      </app-display-icon>
    </div>
  </div>

  <div class="setting-heading">
    Action when on hand (stock) is zero
    <app-display-icon
      (click)="hide.onHandZero = !hide.onHandZero"
      [border]="false"
      [colour]="iconColourEnum.primary"
      [icon]="hide.onHandZero ? icons.chevronDown : icons.chevronUp">
    </app-display-icon>
  </div>

  @if (newSettings.onHandZero !== undefined) {
    <div
      [hidden]="hide.onHandZero"
      class="inputs"
      id="onHold-zero">
      <div>
        <span>Description Prefix</span>
        <input
          [(ngModel)]="newSettings.onHandZero.descPrefix"
          [disabled]="saving">
      </div>
      <div>
        <span>Description Suffix</span>
        <input
          [(ngModel)]="newSettings.onHandZero.descSuffix"
          [disabled]="saving">
      </div>
      <div>
        <span>On Hold Type</span>
        <span class="select">
          {{ newSettings.onHandZero.onHoldCode }}
          <button
            (click)="select($event, 'onHandZero')"
            [disabled]="saving"
            type="button">
            <app-display-icon
              [border]="false"
              [colour]="iconColourEnum.primary"
              [icon]="icons.chevronDown">
            </app-display-icon>
          </button>
        </span>
      </div>
      @if (lineColours) {
        <div>
          <span>Line Colour</span>
          <span class="select">
            @if (newSettings.onHandZero.lineColour) {
              <span
                id="lineColourSelect">
                <!-- [style]="'background:' + lineColours[newSettings.onHandZero.lineColour].value"-->
                {{ newSettings.onHandZero.lineColour }}:
                {{ lineColours[newSettings.onHandZero.lineColour].description }}
              </span>
            }
            <button
              (click)="selectColour($event, 'onHandZero')"
              [disabled]="saving"
              type="button">
              <app-display-icon
                [border]="false"
                [colour]="iconColourEnum.primary"
                [icon]="icons.chevronDown">
              </app-display-icon>
            </button>
          </span>
        </div>
      }
    </div>
  }

  <div class="setting-heading">
    Action when on hand (stock) is <strong>not</strong> zero
    <app-display-icon
      (click)="hide.onHandNotZero = !hide.onHandNotZero"
      [border]="false"
      [colour]="iconColourEnum.primary"
      [icon]="hide.onHandNotZero ? icons.chevronDown : icons.chevronUp">
    </app-display-icon>
  </div>

  @if (newSettings.onHandNotZero !== undefined) {
    <div
      [hidden]="hide.onHandNotZero"
      class="inputs"
      id="onHold-notZero">
      <div>
        <span>Description Prefix</span>
        <input
          [(ngModel)]="newSettings.onHandNotZero.descPrefix"
          [disabled]="saving">
      </div>
      <div>
        <span>Description Suffix</span>
        <input
          [(ngModel)]="newSettings.onHandNotZero.descSuffix"
          [disabled]="saving">
      </div>
      <div>
        <span>On Hold Type</span>
        <span class="select">
          {{ newSettings.onHandNotZero.onHoldCode }}
          <button
            (click)="select($event, 'onHandNotZero')"
            [disabled]="saving"
            type="button">
            <app-display-icon
              [border]="false"
              [colour]="iconColourEnum.primary"
              [icon]="icons.chevronDown">
            </app-display-icon>
          </button>
        </span>
      </div>
      @if (lineColours) {
        <div>
          <span>Line Colour</span>
          <span class="select">
            @if (newSettings.onHandNotZero.lineColour) {
              <span
                >
                <!-- [style]="'background:' + lineColours[newSettings.onHandNotZero.lineColour].value"-->
                {{ newSettings.onHandNotZero.lineColour }}:
                {{ lineColours[newSettings.onHandNotZero.lineColour].description }}
              </span>
            }
            <button
              (click)="selectColour($event, 'onHandNotZero')"
              [disabled]="saving"
              type="button">
              <app-display-icon
                [border]="false"
                [colour]="iconColourEnum.primary"
                [icon]="icons.chevronDown">
              </app-display-icon>
            </button>
          </span>
        </div>
      }
    </div>
  }

  <div class="tools">
    <span></span>
    <span>
      <button
        (click)="save()"
        [disabled]="(!valid()) || saving"
        type="button">
        @if (!saving) {
          <app-display-icon
            class="save-icon"
            [border]="false"
            [colour]="iconColourEnum.yellow"
            [icon]="icons.contentSaveOutline">
          </app-display-icon>
        } @else {
          <span class="spinner spinner-sm" aria-hidden="true"></span>
        }
      </button>
    </span>
  </div>
</div>
